import React from 'react';
import FeatureSummary from '../../../Util/FeatureSummary';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../Table/DetailsTable';

const CobrandEmailSendersTable = ({
    cobrandEmailSenders,
    loading,
    editOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                    id={item.cobrandEmailSenderId}
                    item={item}
                />
            ),
        },
        {
            name: 'Cobrand Name',
            fieldName: 'cobrandName',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'From Name',
            fieldName: 'fromName',
            minWidth: 120,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: 'From Email',
            fieldName: 'fromEmailAddress',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
        },
        {
            name: 'Reply To',
            fieldName: 'replyToEmail',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
        },
    ];

    const items = cobrandEmailSenders ?? [];

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                loading={loading}
                mainColumn={'cobrandName'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Add' }}
                        text="Add Cobrand Email Sender"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                summary="This table displays cobrand-to-email-sender assignments. Each row links a cobrand to an email sender, showing the cobrand name and the sender's from name, email address, and reply-to address. You can add, edit, or delete assignments."
                label="About Cobrand Email Senders"
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'edit',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: 'delete',
                iconProps: { iconName: 'Delete' },
                text: 'Delete',
                onClick: () => deleteOnClick(id, item?.cobrandName || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CobrandEmailSendersTable;
